import { useCallback, useEffect } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useAppEventEmitter from 'src/hooks/useAppEventEmitter';

// Shared ref to coordinate between reset and pin hooks
export const isResettingRef = { current: false };

export const useSyncResetTradeForm = (
	selectedMarketKey: string | undefined,
	currentAccountUserKey: string | undefined
) => {
	const appEventEmitter = useAppEventEmitter();

	const set = useDriftStore((s) => s.set);

	const resetTradeForm = useCallback(
		({ clearInputs }: { clearInputs?: boolean } = {}) => {
			// Set flag to prevent pin hook from interfering
			isResettingRef.current = true;

			// Reset everything synchronously in one store update
			set((s) => {
				// @ts-expect-error :: Reset maxLeverageSelected FIRST and synchronously
				s.tradeForm.maxLeverageSelected = false;

				if (clearInputs) {
					// @ts-expect-error
					s.tradeForm.priceBoxStringValue = '';
					// @ts-expect-error
					s.tradeForm.secondaryPriceBoxStringValue = '';
					// @ts-expect-error
					s.tradeForm.baseSizeStringValue = '';
					// @ts-expect-error
					s.tradeForm.quoteSizeStringValue = '';

					// We only uncheck the TP/SL checkbox here, removing bracket orders is
					// handled within `useTpSlOrderFormSideEffects`.
					s.tradeForm.isTpSlCheckboxChecked = false;
				}
			});

			// Clear the resetting flag after React has processed the update
			setTimeout(() => {
				isResettingRef.current = false;
			}, 0);
		},
		[set]
	);

	// Reset the form when the market or user account changes
	useEffect(() => {
		resetTradeForm({ clearInputs: true });
	}, [selectedMarketKey, currentAccountUserKey, resetTradeForm]);

	// Reset the form when a transaction goes through successfully
	useEffect(() => {
		appEventEmitter.on('tradeConfirmation', resetTradeForm);

		return () => {
			appEventEmitter.removeListener('tradeConfirmation', resetTradeForm);
		};
	}, [appEventEmitter, resetTradeForm]);
};
